export type NameType = 'logoShrinking';

export const name: NameType = 'logoShrinking';
